import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchAccountListResponse>}
 */
export function requestAccountList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/account`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/account?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function requestCreateAccount(data) {
  return fetch.post(`${BASE_URL}/api/app/account`, data);
}
export function requestUpdateAccount(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/account/${data._id}`, body);
}
export function requestAccountDropDownList(params) {
  return fetch.get(`${BASE_URL}/api/app/account/get-accounts`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}
export function requestGetByIdAccount(data) {
  return fetch.get(`${BASE_URL}/api/app/account/getById/${data.id}`);
}

export function requestLocationAccountList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/account/location-accounts-filter`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/account/location-accounts-filter?${params}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}

// .then((response) => response.json())
//   .then((data) => {
//     console.log("Success:", data);
//   })
//   .catch((error) => {
//     console.error("Error:", error);
//   }); 

// export async function requestGenerateClientId(data) {
//   const response = await fetch.get(`${BASE_URL}/api/app/account/generate_client_id/${data.id}`);
//   const data_1 = response.json();
//   console.log("data", data_1);
//   if(response){
//    return fetch.get(`${BASE_URL}/api/app/account/md_dump_data/${data.id}`)
//   }
//   }

 export  function requestGenerateClientId(data) {
    return fetch.post(`${BASE_URL}/api/app/account/generate_client_id`,data);    
    }  

    
    export  function requestGenerateDumpId(data) {
     
      return fetch.get(`${BASE_URL}/api/app/account/md_dump_data/${data._id}`)    
      } 
      
// export function requestGenerateClientId(data) {  
//    let type = data.id.split('$'); 
//    console.log(data,type);
//     if(type.length>0){ 
//          if(type[1]=='md'){ 
//              return fetch.get(`${BASE_URL}/api/app/account/md_dump_data/${data.id}`); 
//            }else{ 
//            return fetch.get(`${BASE_URL}/api/app/account/generate_client_id/${data.id}`);} 
//            } else{ 
//                return fetch.get(`${BASE_URL}/api/app/account/generate_client_id/${data.id}`);
//               }}
// export function requestGenerateClientId(data){

// }

/**
 * 
 *
 */

// Update Account Profile List Service
export function requestUpdateAccountProfileList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/client-account-profile`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/client-account-profile?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
// Update Account Profile Update Service
export function requestUpdateAccountProfile(data) {
  return fetch.post(`${BASE_URL}/api/app/client-account-profile`, data);
}

export function requestCreateAccountDetails(data) {
  return fetch.post(`${BASE_URL}/api/app/client-account-profile/`, data);
}
// Edit Account Profile Update Service
export function requestEditUpdateAccountProfile(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.put(`${BASE_URL}/api/app/client-account-profile/${data._id}`, body);
}

// Edit Account Profile Update Service
export function requestUpdateSDWaiveOff(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.patch(`${BASE_URL}/api/app/account/sdWaveOff/${data._id}`, body);
}

export function requestUpdateSDDue(data) {
  const body = { ...data };
  delete body["_id"];
  return fetch.patch(`${BASE_URL}/api/app/account/updateComments/${data._id}`, body);
}

export function requestclientAccountIdAgreementList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement?${params}`
    );
  }
}
export function requestCreateProposalAccountList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/getwonproposals`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/getwonproposals?${params}`
    );
  }
}

export function fetchAgreementDataForAccount(param) {
  return fetch.get(`${BASE_URL}/api/app/account/get_agreement_data/${param}`);
}

export function requestGetByIdProposalGenerate(data) {
  // return fetch.get(`${BASE_URL}/api/app/smart-proposal/getById/${data}`);
  return fetch.get(`${BASE_URL}/api/app/smart-proposal/getwonproposaldetails/${data}`);
}

export function requestGetByIdProposalOtView(data) {
  return fetch.get(`${BASE_URL}/api/app/smart-proposal/getById/${data}`);
  //return fetch.get(`${BASE_URL}/api/app/smart-proposal/getwonproposaldetails/${data}`);
}

export function requestCreateProposalProfile(data) {
  return fetch.post(`${BASE_URL}/api/app/account/createproposalaccount`, data);
}

export function requestAccountBookingList(params) {
    return fetch.get(
      `${BASE_URL}/api/app/sync-meetingroom/getBookingDetails?${params}`
    );
}
export function requestBookingByAccountList(params) {
  return fetch.get(
    `${BASE_URL}/api/app/sync-meetingroom/getBookingByAccount?${params}`
  );
}

export function requestSyncFailedMember(params) {
  return fetch.get(
    `${BASE_URL}/api/app/sync-meetingroom/syncNoUserBookingData?${params}`
  );
}